import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import userStates from '@/store/module-user-states'
import patientsStates from '@/store/module-patients-states'
import bhUsersStates from '@/store/module-bh-users'
import practicesStates from '@/store/module-practices-states'
import appStates from '@/store/module-app-states'
import headersStates from '@/store/module-headers-states'
import chatStates from '@/store/module-chat-states'
import libraryStates from '@/store/module-library-states'
import dictionariesStates from '@/store/module-dictionaries-states'
import templatesStates from '@/store/module-templates-states'
import exercisesStates from '@/store/module-exercises-states'
import resourcesStates from '@/store/module-resources-states'
import profilePreviewsStates from '@/store/module-profile-previews-states'
import screenersStates from '@/store/module-screeners-states'
import surveyStates from '@/store/module-screener-form-states'
import adminLogsStates from '@/store/module-admin-logs-states'
import staticMediaStates from '@/store/module-static-media-states'
import coursesStates from '@/store/module-courses-states'
import programsStates from '@/store/module-programs-states'
import journeysStates from '@/store/module-journeys-states'
import languagesStates from '@/store/module-languages-states'
import reportsGenerateStates from '@/store/module-reports-generate-states'

Vue.use(Vuex)

const persistedData = createPersistedState({
  // list of stores we want to persist
  paths: ['userStates'],
})

const store = new Vuex.Store({
  modules: {
    userStates,
    patientsStates,
    bhUsersStates,
    practicesStates,
    appStates,
    headersStates,
    chatStates,
    libraryStates,
    dictionariesStates,
    templatesStates,
    exercisesStates,
    resourcesStates,
    profilePreviewsStates,
    screenersStates,
    surveyStates,
    adminLogsStates,
    staticMediaStates,
    coursesStates,
    programsStates,
    journeysStates,
    languagesStates,
    reportsGenerateStates,
  },
  plugins: [persistedData],
})

export default store
